export default __webpack_public_path__ + "static/media/gallery6.be6d8a18.JPG";